import PropTypes from 'prop-types';
import { useState } from 'react';
import { answerInquiry } from './inquiryApi';
import './InquiryAnswerForm.css';

// 답변 전 확인 문구. 답변이 등록되면 사용자에게 답변 완료 메일이 간다(사용자 문의 화면 안내 기준).
const CONFIRM_MESSAGE = '답변을 등록할까요? 등록하면 작성자에게 답변 완료 메일이 발송됩니다.';

// 답변 대기 문의에 답변을 작성해 등록하는 폼. 성공하면 onAnswered를 호출한다.
export default function InquiryAnswerForm({ inquiryId, onAnswered }) {
    const [answer, setAnswer] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');

    // 답변을 확인받은 뒤 등록한다.
    const handleSubmit = async e => {
        e.preventDefault();
        const trimmed = answer.trim();
        if (!trimmed) {
            setError('답변 내용을 입력해주세요.');
            return;
        }
        if (!window.confirm(CONFIRM_MESSAGE)) return;
        setSubmitting(true);
        setError('');
        try {
            await answerInquiry(inquiryId, trimmed);
            onAnswered();
        } catch (submitError) {
            setError(submitError.message);
            setSubmitting(false);
        }
    };

    return (
        <form className="admin-answer-form" onSubmit={handleSubmit} noValidate>
            <label htmlFor="admin-answer">답변 작성</label>
            <textarea id="admin-answer" value={answer} onChange={e => { setAnswer(e.target.value); setError(''); }} rows={8} disabled={submitting} placeholder="작성자에게 보낼 답변을 입력하세요." />
            {error && <p className="admin-answer-error" role="alert">{error}</p>}
            <button type="submit" disabled={submitting}>{submitting ? '등록 중...' : '답변 등록'}</button>
        </form>
    );
}

InquiryAnswerForm.propTypes = {
    inquiryId: PropTypes.string.isRequired,
    onAnswered: PropTypes.func.isRequired,
};
